import createPlugin from './createPlugin'
import FormRenderer from './Renderer/FormRenderer'

const formPlugin = settings =>
    createPlugin({
        Renderer: FormRenderer,
        ...settings,
    })

const Form = formPlugin()
export default Form

export { formPlugin, FormRenderer }
